module.exports = __webpack_public_path__ + "static/media/early5.2af76d68.JPG";